import {useState} from 'react';

export const useLineClamp = () => {
  const [opened, setLineClamp] = useState(false);

  const handleMoreClick = () => {
    if (opened) {
      setLineClamp(false);
    } else {
      setLineClamp(true);
    }
  };

  return [opened, handleMoreClick] as const;
};
